import { Dropdown } from "antd";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { BellOutlined } from "@ant-design/icons";
import NotificationsList from "../../Notifications";
import NotificationTour from "./NotificationTour";
import { SocketContext } from "../../../context/Socket";
import { useNotificationsContext } from "../../Notifications/context";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";
import { useApp } from "../../../helpers/user";

export default function Notifications({
  hasNotifications,
  isUserApproved,
  projects = [],
  unApprovedProjects,
  userPreferences = [],
  module = 'pme',
}) {
  const notiIconRef = useRef();
  const [tourIsVisible, setTourIsVisible] = useState(false);
  const app = useApp();
  const {
    notificationsBellClicked,
    // hasStartedNotifications,
  } = useContext(SocketContext);
  const { total, _notifications } = useNotificationsContext();

  useEffect(() => {
    if (projects?.length) {
      setTourIsVisible(false);
    }

    if (userPreferences) {
      if (!userPreferences.find((p) => p.key === 'notification_steper')) {
        const n = _notifications.find((n) => ['projectSourceInvite', 'projectClientInvite', 'programPartnerInvite'].includes(n.type))
        setTourIsVisible(!!n);
      }
    }
  }, [_notifications, userPreferences, projects]);

  const showNotifications = () => (
    <NotificationsList
      mod={module}
      toggle={() => notiIconRef.current.click()}
    />
  );

  const items = [
    {
      key: 'notifications',
      label: showNotifications(),
      disabled: true,
    }
  ];

  return (
    <>
      <Dropdown
        onOpenChange={notificationsBellClicked}
        menu={{ items }}
        rootClassName={formatClassname(['dark-menu min-w-300', app])}
        trigger={['click']}
        placement="bottom"
      >
        <div className="notification-icon" ref={notiIconRef}>
          {/* {hasStartedNotifications && <div className="noti-loader" />} */}
          <BellOutlined />
          {total ? (
            <div className="noti-more-cont">
              {total}
            </div>
          ) : null}
        </div>
      </Dropdown>

      {tourIsVisible ? <NotificationTour module={module} total={total} /> : null}
    </>
  )
}
